// Relative so the request targets whatever origin the app is served from
// (http://localhost:81 in dev, https://iclimb.io in prod). This keeps local
// testing working without env-specific builds.
const apiBaseUrl = '/api/';

// The properties upload lives on Laravel now — see propertyImportApi in
// requests/api.js. Duplicate matching and the owner/investor links are both
// database work, and the Node handler could only ask Arc for them.

// Upload Comps (Costar comps CSV)
export const apiUploadCompsUrl = `${apiBaseUrl}upload-comps`;
export const apiUploadCompsStatusUrl = `${apiBaseUrl}upload-comps-status`;
// POST `${apiUploadCompsUrl}/${jobId}/commit` triggers the actual DB writes
// after the user approves the dry-run preview.
export const apiUploadCompsCommitUrl = `${apiBaseUrl}upload-comps`;

// Email notifications: scheduled sync + optional immediate sends (property diff or template + variables)
export const apiEmailNotificationsSyncUrl = `${apiBaseUrl}email-notifications/sync-property`;

// Sync Rates Scraper
export const apiSyncRatesUrl = `${apiBaseUrl}rates/sync`;
